/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface IgnitionOnEventOffsetEUMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for ignition on events of the asset
 *
 * ```typescript
 *  import {getIgnitionOnEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getIgnitionOnEventOffsetEUMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getIgnitionOnEventOffsetEUMarker = ({
  fillColor = dlsColor('caGreen'),
  borderColor = dlsColor('white'),
  size = 48
}: IgnitionOnEventOffsetEUMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='12' width='24' height='24' rx='12' fill='${borderColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 34C6.47715 34 2 29.5228 2 24C2 18.4772 6.47715 14 12 14C17.5228 14 22 18.4772 22 24C21.9938 29.5203 17.5203 33.9938 12 34Z' fill='${fillColor}'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getIgnitionOnEventOffsetEUMarker;
